export default __webpack_public_path__ + "static/media/search-icon.9da852b9.svg";